import BreadCrumb from "@componentsShared/BreadCrumb";
import stl from "./Banner.module.css";
import {useTranslation} from "@i18n";
import {useLang} from "@/common/Contexts/LanguageContext";
import useHelpers from "@hooks/useHelpers";

const Banner = ({ cityName }) => {
    const lang = useLang();
  const { t } = useTranslation(["web_city","web_common"]);
  const {createUrl} = useHelpers()
  return (
    <>
      <div className={stl.BC_container}>
        <BreadCrumb
          
          className={stl.brdCrmb}
          links={[
            {
              title: t("المدن", { ns: "web_common" }),
              link: createUrl("/city"),
            },
            {
              title: cityName,
            },
          ]}
        />
        <h1>
          {t("سيارات للبيع في {{cityName}}", {
            ns: "web_city",
            cityName: cityName,
          })}
        </h1>
        <p>
          {" "}
          {t("نوصلك المركبة الي بتشتريها من سيارة إلى {{cityName}}", {
            ns: "web_city",
            cityName: cityName,
          })}
        </p>
      </div>
    </>
  );
};

export default Banner;
